var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.125 61.8742C33.125 64.2663 35.0838 66.2055 37.5 66.2055H54.5833C55.7532 66.2055 56.8743 65.7416 57.6963 64.9175L90.613 31.9176C92.3032 30.2231 92.2946 27.4955 90.5936 25.8116L73.9269 9.31156C72.226 7.62762 69.4709 7.61904 67.7593 9.29236L34.4259 41.8799C33.5935 42.6936 33.125 43.8036 33.125 44.9617V61.8742ZM52.755 57.543H41.875V46.7718L57.1871 31.8023L67.8757 42.384L52.755 57.543ZM74.024 36.2201L81.3322 28.8934L70.8139 18.4803L63.4132 25.7155L74.024 36.2201Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 12.3742C8.125 9.98214 10.0838 8.04297 12.5 8.04297H45.625C48.0412 8.04297 50 9.98214 50 12.3742C50 14.7663 48.0412 16.7055 45.625 16.7055H16.875V82.293H83.125V53.8305C83.125 51.4384 85.0837 49.4992 87.5 49.4992C89.9162 49.4992 91.875 51.4384 91.875 53.8305V86.6242C91.875 89.0163 89.9162 90.9555 87.5 90.9555H12.5C10.0838 90.9555 8.125 89.0163 8.125 86.6242V12.3742Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/Notice.c120933d03e11d26b640583c4e35cab5.svg";
export { ForwardRef as ReactComponent };